import { render } from "./BannerCardPreview.vue?vue&type=template&id=44fca675&scoped=true"
import script from "./BannerCardPreview.vue?vue&type=script&lang=js"
export * from "./BannerCardPreview.vue?vue&type=script&lang=js"

import "./BannerCardPreview.vue?vue&type=style&index=0&id=44fca675&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fca675"]])

export default __exports__